import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    ConstructionDiaryState,
    CONSTRUCTION_DIARY_KEY,
    selectAllConstructionDiaries,
    selectConstructionDiaryEntities,
     selectConstructionDiariesFetchedByCommissionId,
    selectConstructionDiaryLatestUpdatedAtByCommissionId,
} from '../reducers/construction-diary.reducer';
import { State } from '../index';

export const getConstructionDiaryState = (state: State) => state[CONSTRUCTION_DIARY_KEY];

export const getAllConstructionDiaries = createSelector(getConstructionDiaryState, selectAllConstructionDiaries);
export const getConstructionDiaryEntities = createSelector(getConstructionDiaryState, selectConstructionDiaryEntities);

export const getConstructionDiariesFetchedByCommissionId = createSelector(getConstructionDiaryState, selectConstructionDiariesFetchedByCommissionId);
export const getConstructionDiaryLatestUpdatedAtByCommissionId = createSelector(getConstructionDiaryState, selectConstructionDiaryLatestUpdatedAtByCommissionId);

export const getConstructionDiaryFetchedByCommissionId = (commissionId: number) => createSelector(getConstructionDiariesFetchedByCommissionId, (map) => !!map[commissionId]);

export const getConstructionDiaryLatestUpdatedAtForCommissionId = (commissionId: number) =>
    createSelector(getConstructionDiaryLatestUpdatedAtByCommissionId, (map) => map[commissionId] ?? null);

export const getConstructionDiariesByCommissionId = (commissionId: number) =>
    createSelector(getAllConstructionDiaries, (diaries) => diaries.filter((d) => d.CommissionId === commissionId));

